import React from "react";
import { ExternalLink } from "lucide-react";
import { api } from "../lib/api";

// Under-18 forbidden badge (FDJ style: red circle with "18" and a bar)
export const Under18Badge = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" role="img" aria-label="Interdit aux moins de 18 ans">
    <circle cx="24" cy="24" r="22" fill="#fff" stroke="#E11D48" strokeWidth="4" />
    <text x="24" y="30" textAnchor="middle" fontSize="18" fontWeight="900" fill="#0B132B" fontFamily="Arial, sans-serif">18</text>
    <line x1="9" y1="39" x2="39" y2="9" stroke="#E11D48" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export function trackAffiliateClick(game) {
  // Fire-and-forget; navigation happens in a new tab regardless.
  api.post("/affiliate-click", { game }).catch(() => {});
}

export const PlayFdjButton = ({ url, game, gameColor, size = "md", testId }) => {
  if (!url) return null;
  const pad = size === "sm" ? "px-4 py-2 text-sm" : "px-5 py-2.5";
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer nofollow sponsored"
      onClick={() => trackAffiliateClick(game)}
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 rounded-full font-bold text-white shadow-md hover:scale-[1.03] active:scale-[0.98] transition-all ${pad}`}
      style={{ background: gameColor || "#D4001A" }}
    >
      Jouer sur FDJ <ExternalLink className="w-4 h-4" />
    </a>
  );
};
